/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ taken: NonNullable<unknown>, total: NonNullable<unknown> }} Features_SeatsInputs */

const en_features_seats = /** @type {(inputs: Features_SeatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.taken}/${i?.total} seats`)
};

const pl_features_seats = /** @type {(inputs: Features_SeatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.taken}/${i?.total} miejsc`)
};

/**
* | output |
* | --- |
* | "{taken}/{total} seats" |
*
* @param {Features_SeatsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_seats = /** @type {((inputs: Features_SeatsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_SeatsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_seats(inputs)
	return en_features_seats(inputs)
});